import { errorToJson } from './index';

const RETRY_ERROR_NAME = 'RetryError';

export default class RetryError extends Error {
    public name = RETRY_ERROR_NAME;

    public constructor(public errors: Array<Error>) {
        super();
        this.message = errors
            .map((err, index) => {
                if (typeof err === 'string') {
                    return `[${index}] ${err}`;
                }
                return `[${index}] ${err.message}`;
            })
            .join('\n');
    }

    public toJson = () => {
        return {
            ...errorToJson(this),
            errors: this.errors.map(errorToJson),
        };
    };

    public static isRetryError(error: Error): error is RetryError {
        return error.name === RETRY_ERROR_NAME;
    }
}
